import React from 'react'
import gql from 'graphql-tag'
import {Mutation} from 'react-apollo'
import {Checkbox, Radio, Button, Input, Alert, message} from 'antd'
import scaleCompressImage from 'lib/scaleCompressImage'

import './index.css'

const addBookingDeviation = gql`
  mutation AddBookingDeviation($input: AddBookingDeviationInput!) {
    AddBookingDeviation(input: $input) {
      text
    }
  }
`

const DEVIATION_OPTIONS = [
  {value: 'not_cleaned', label: 'Ikke ryddet'},
  {value: 'seller_not_home', label: 'Selger ikke hjemme'},
  {value: 'weather', label: 'Værforhold'},
  {value: 'other', label: 'Annet'},
]

const DEVIATION_TYPES = [
  {value: 'no_cancel', label: 'Ingen'},
  {value: 'wasted_trip', label: 'Bomtur'},
  {value: 'cancel_with_fee', label: 'Kansellering samme dag, med gebyr'},
  {value: 'cancel_without_fee', label: 'Kansellering uten gebyr'}
]

class BookingDeviationPage extends React.Component {
  state = {
    reasons: [],
    deviationType: DEVIATION_TYPES[0].value,
    customerInformed: null,
    text: '',
    attachment: null,
    submitting: false,
    showConfirmation: false,
  }

  submit(mutation) {
    const {reasons, text, deviationType, attachment, customerInformed} = this.state
    const input = {
      bookingId: this.props.booking.id,
      reasons,
      text,
      attachment,
      deviationType,
      customerInformed,
    }

    this.setState({submitting: true})

    return mutation({
      variables: {
        input,
      }
    })
  }

  submitSuccessful() {
    this.setState({showConfirmation: true, submitting: false})
  }

  submitError() {
    this.setState({submitting: false})
    message.error('Beklager, noe gikk galt ved melding av avvik', 2000)
  }

  updateStateObject({stateObject, key, checked, value = true}) {
    if (checked) stateObject[key] = value
    else delete stateObject[key]

    this.setState({[stateObject]: stateObject})
  }

  changeDeviation(reasons) {
    this.setState({reasons})
  }

  setDeviationType(deviationType) {
    this.setState({deviationType})
  }

  changeCustomerInformed(customerInformed) {
    this.setState({customerInformed})
  }

  updateText(text) {
    this.setState({text})
  }

  async fileSelected(file) {
    const attachment = await scaleCompressImage(file)
    this.setState({attachment})
  }

  formValid() {
    return (this.state.reasons.length && this.state.customerInformed !== null)
  }

  deviationForm() {
    return (
      <div>
        <div className="section">
          <h4>Velg én eller flere årsaker til avviket:</h4>
          <Checkbox.Group
            options={DEVIATION_OPTIONS}
            value={this.state.reasons}
            onChange={checkedValues => this.changeDeviation(checkedValues)}
          />
        </div>

        <div className="section">
          <h4>Spesifiser avviket:</h4>
          <Input.TextArea
            placeholder="Spesifiser informasjon om avviket; årsak og evt ny avtale med megler"
            autoSize
            onChange={evt => this.updateText(evt.target.value)}
          />
        </div>

        <div className="section">
          <h4>Kansellering:</h4>
          <Radio.Group
            value={this.state.deviationType}
            onChange={e => this.setDeviationType(e.target.value)}
          >
            {DEVIATION_TYPES.map(({value, label}) => (
              <Radio key={value} value={value}>{label}</Radio>
            ))}
          </Radio.Group>
        </div>

        <div className="section">
          <h4>Er megler informert?</h4>
          <Radio.Group onChange={e => this.changeCustomerInformed(e.target.value)} value={this.state.customerInformed}>
            <Radio value={true}>Ja</Radio>
            <Radio value={false}>Nei</Radio>
          </Radio.Group>
        </div>

        <div className="section">
          <h4>Vedlegg:</h4>
          <input
            type="file" onChange={evt => this.fileSelected(evt.target.files[0])}
            accept="image/*"
          />
        </div>

        <Mutation
          mutation={addBookingDeviation}
          onCompleted={() => this.submitSuccessful()}
          onError={err => this.submitError(err)}
        >
          {(addBookingDeviation) => {
            return (
              <Button
                type="primary"
                className="send-deviation-button"
                disabled={!this.formValid() || this.state.submitting}
                onClick={() => this.submit(addBookingDeviation)}
              >
                Send avvik
              </Button>
            )
          }}
        </Mutation>
      </div>
    )
  }

  render() {
    if (this.state.showConfirmation) {
      return (
        <Alert
          type="success"
          message="Vi har logget avvik i bookingen"
          description="Kundeservice og megleren vil bli informert. Hvis du trenger raskere hjelp, vennligst ta kontakt med kundeservice eller megleren direkte."
        />
      )
    }

    return this.deviationForm()
  }
}

export default BookingDeviationPage
